import { Stack, Typography } from '@mui/material';
import EmptyBarChartAsset from './EmptyBarChart.svg?react';

export const EmptyBarChart = ({ emptyText, height }: { emptyText?: string; height?: number }) => {
    return (
        <Stack justifyContent="center" alignItems="center" p={emptyText ? 4 : 0} minHeight={height}>
            <EmptyBarChartAsset height={emptyText ? 66 : 33} />
            {emptyText ? (
                <Stack spacing={0.5}>
                    <Typography textAlign="center" color={'text.primary'}>
                        No data to display
                    </Typography>
                    <Typography variant="body2" color="text.secondary" textAlign="center">
                        {emptyText}
                    </Typography>
                </Stack>
            ) : (
                <Typography textAlign="center" color="text.disabled">
                    There is currently no data to display
                </Typography>
            )}
        </Stack>
    );
};
